export const getApiErrorMessage = (error, fallback = 'Something went wrong.') => {
  return error?.response?.data?.message ?? fallback
}

export const getApiFieldErrors = (error) => {
  const rawErrors = error?.response?.data?.errors

  if (!rawErrors || typeof rawErrors !== 'object') {
    return {}
  }

  return Object.entries(rawErrors).reduce((carry, [field, messages]) => {
    if (Array.isArray(messages) && messages.length > 0) {
      carry[field] = String(messages[0])
      return carry
    }

    if (typeof messages === 'string' && messages.length > 0) {
      carry[field] = messages
    }

    return carry
  }, {})
}
